import React, { useMemo, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAreaTareas } from '../hooks/useAreaTareas';
import { useTareas } from '../hooks/useTareas';
import { ReordenAreaTareaForm } from '../types';

const AreaTareasPage: React.FC = () => {
  const params = useParams();
  const areaId = Number(params.areaId);
  const { areaTareas, isLoading, addAreaTarea, excludeAreaTarea, reinstateAreaTarea, reorderAreaTareas, updateAreaTareaConfig } = useAreaTareas(areaId);
  const { tareas } = useTareas();
  const [selectedTareaId, setSelectedTareaId] = useState<number | ''>('');

  const opcionesTareas = useMemo(() => {
    const asignadas = new Set(areaTareas.map(at => at.tareaId));
    return tareas.filter(t => !asignadas.has(t.id));
  }, [tareas, areaTareas]);

  const handleAdd = () => {
    if (typeof selectedTareaId === 'number') {
      addAreaTarea({ tareaId: selectedTareaId, orden: (areaTareas[areaTareas.length - 1]?.orden || 0) + 1, obligatoria: false });
      setSelectedTareaId('');
    }
  };

  const handleReorder = () => {
    const ordenes: ReordenAreaTareaForm[] = areaTareas.map((at, idx) => ({ tareaId: at.tareaId, orden: idx + 1 }));
    reorderAreaTareas(ordenes);
  };

  if (!areaId || Number.isNaN(areaId)) {
    return <div className="p-6">Área inválida</div>;
  }

  if (isLoading) {
    return <div className="p-6">Cargando tareas del área...</div>;
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-xl font-semibold">Tareas del Área</h1>
        <Link to="/areas" className="text-indigo-600 text-sm">Volver a Áreas</Link>
      </div>

      <div className="bg-white p-4 rounded shadow mb-4 flex gap-2 items-end">
        <div className="flex-1">
          <label className="block text-sm text-gray-700">Agregar tarea</label>
          <select value={selectedTareaId} onChange={(e) => setSelectedTareaId(e.target.value ? Number(e.target.value) : '')} className="mt-1 w-full border rounded px-2 py-1">
            <option value="">Seleccionar tarea</option>
            {opcionesTareas.map(t => (
              <option key={t.id} value={t.id}>{t.nombre}</option>
            ))}
          </select>
        </div>
        <button onClick={handleAdd} className="bg-indigo-600 text-white px-3 py-2 rounded">Agregar</button>
      </div>

      <div className="bg-white rounded shadow">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="bg-gray-50 text-left">
              <th className="px-4 py-2">Orden</th>
              <th className="px-4 py-2">Nombre</th>
              <th className="px-4 py-2">Heredada</th>
              <th className="px-4 py-2">Obligatoria</th>
              <th className="px-4 py-2">Activa</th>
              <th className="px-4 py-2">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {areaTareas.map((at, idx) => (
              <tr key={at.id} className="border-t">
                <td className="px-4 py-2">{idx + 1}</td>
                <td className="px-4 py-2">{at.tareaNombre}</td>
                <td className="px-4 py-2">{at.heredada ? 'Sí' : 'No'}</td>
                <td className="px-4 py-2">
                  <input type="checkbox" checked={at.obligatoria} onChange={(e) => updateAreaTareaConfig({ tareaId: at.tareaId, payload: { obligatoria: e.target.checked } })} />
                </td>
                <td className="px-4 py-2">
                  <input type="checkbox" checked={at.activo} onChange={(e) => updateAreaTareaConfig({ tareaId: at.tareaId, payload: { activo: e.target.checked } })} />
                </td>
                <td className="px-4 py-2 flex gap-2">
                  {at.excluida ? (
                    <button className="text-green-700" onClick={() => reinstateAreaTarea(at.tareaId)}>Reincorporar</button>
                  ) : (
                    <button className="text-red-700" onClick={() => excludeAreaTarea(at.tareaId)}>Excluir</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-3">
        <button onClick={handleReorder} className="text-sm text-gray-700">Guardar orden actual</button>
      </div>
    </div>
  );
};

export default AreaTareasPage;


